import { View, Text } from 'react-native'
import { ShieldCheck } from '@/components/ui/icons'
import { useTheme } from '@/lib/hooks/use-theme'
import { useSemanticColors, withAlpha } from '@/lib/theme/tokens'
import { COLORS, FONTS, RADIUS, SPACING } from '@/lib/brand'

export function CheckoutSecureHeader({
  title,
  description,
}: {
  title: string
  description: string
}) {
  const { isDark } = useTheme()
  const colors = useSemanticColors(isDark)

  return (
    <View style={{ flexDirection: 'row', gap: SPACING.sm, alignItems: 'flex-start' }}>
      <View
        style={{
          width: 44,
          height: 44,
          borderRadius: RADIUS.md,
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: withAlpha(COLORS.coral.DEFAULT, 0.07),
        }}
      >
        <ShieldCheck size={22} color={COLORS.coral.DEFAULT} strokeWidth={2} />
      </View>
      <View style={{ flex: 1 }}>
        <Text
          style={{
            fontSize: 17,
            fontFamily: FONTS.bodyBold,
            color: colors.textPrimary,
            marginBottom: SPACING.xs,
          }}
        >
          {title}
        </Text>
        <Text
          style={{
            fontSize: 13,
            lineHeight: 19,
            fontFamily: FONTS.body,
            color: colors.textSecondary,
          }}
        >
          {description}
        </Text>
      </View>
    </View>
  )
}
